import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromStaticDataReducer from '../reducers';
import * as staticDataMainReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getStaticDataState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataBusinessNamesState = createSelector(
  getStaticDataState,
  state => state[fromStaticDataReducer.fromStaticDataBusinessNamesReducer.businessNamesFeatureKey]
);

export const getStaticDataBusinessNamesFailure = createSelector(
  getStaticDataBusinessNamesState,
  staticDataMainReducer.fromStaticDataBusinessNamesReducer.getStaticDataBusinessNamesFailure
);

export const getStaticDataBusinessNamesResponse = createSelector(
  getStaticDataBusinessNamesState,
  staticDataMainReducer.fromStaticDataBusinessNamesReducer.getStaticDataBusinessNamesResponse
);
